
import React, { useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import ContractLifecycleContent from "@/components/expertise/ContractLifecycleContent";

const ContractLifecycle = () => {
  useEffect(() => {
    document.title = "AI Contract Lifecycle Management | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI contract lifecycle management solutions. Automate creation, review & analysis. Reduce risk, increase efficiency. Learn more.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'AI contract lifecycle management solutions. Automate creation, review & analysis. Reduce risk, increase efficiency. Learn more.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <div className="pt-24 bg-background min-h-screen">
        <ContractLifecycleContent />
      </div>
      <FooterSection />
    </>
  );
};

export default ContractLifecycle;
